<template>
  <div class="servicios">
    <v-container fluid class="py-0">
      <!-- *************row 1 intro******************* -->
      <v-row id="servicios">
        <v-col cols="12" class="py-0 px-0">
          <div class="wrap">
            <div>
              <v-img src="@/assets/img/Servicio-portada.jpg" class="intro-img"></v-img>
            </div>

            <div class="overlay">
              <div class="text-overlay">
                <span class="bold">Servicios</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- *************/row 1 intro******************* -->

      <!-- *************row 2******************* -->
      <v-row>
        <template v-for="(service, sr) in services">
          <v-col cols="12" :md="12/service.columns" class="pa-0" :key="sr">
            <div class="wrap-columns">
              <div>
                <v-img :src="'https://www.mlcpcms.actstudio.xyz/'+service.cover.path" class="img-cover-services"></v-img>
              </div>
              <div
                class="overlay-columns"
                v-bind:class="{'red-column' : service.color == 'red', 'gray-column' : service.color == 'gray', 'black-column' : service.color == 'black', 'blue-column' : service.color == 'blue'}"
              >
                <div class="card-position">
                  <div>
                    <v-img
                      :src="'https://www.mlcpcms.actstudio.xyz/'+service.iconCover.path"
                      class="d-block mx-auto img-icon-services"
                    ></v-img>
                  </div>
                  <div class="text-center">
                    <span class="d-block mt-5 card-title-mine uppercase">{{service.TituloDeServicio}}</span>
                  </div>
                </div>
              </div>
              <div
                class="overlay2"
                v-bind:class="{'red-overlay' : service.color == 'red', 'gray-overlay' : service.color == 'gray', 'black-overlay' : service.color == 'black', 'blue-overlay' : service.color == 'blue'}"
              >
                <div class="service-description">
                  <div class="text-center">
                    <span class="d-block mt-5 card-title-mine uppercase">{{service.TituloDeServicio}}</span>
                  </div>

                  <div class="mt-5 div-description-overlay2">
                    <span class="text-general">{{service.introText}}...</span>
                  </div>

                  <div class="text-center mt-12">
                    <router-link
                      :to="'/servicio/'+service.urlService"
                      class="link-see-more text-general link-with-decoration"
                    >Ver más</router-link>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="overlay-mobile px-5 pt-5 d-md-none"
            v-bind:key="'mobile'+sr"
            v-bind:class="{'red-overlay' : service.color == 'red', 'gray-overlay' : service.color == 'gray', 'black-overlay' : service.color == 'black', 'blue-overlay' : service.color == 'blue'}"
          >
            <div>
              <p
                class="text-general white--text height-description-services-mobile"
              >{{service.introText}}</p>

              <div class="text-center pt-2">
                <router-link
                  :to="'/servicio/'+service.urlService"
                  class="link-see-more text-general link-with-decoration white--text"
                >
                  <span>Ver más</span>
                </router-link>
              </div>
            </div>
          </v-col>
        </template>
      </v-row>
      <!-- *************/row 2******************* -->
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    services: [],
  }),
  created() {
    //traer los servicios
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/servicios?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((res) => (this.services = res.entries))
      .catch((error) => console.log(error.message));
  },
  mounted: function () {
    this.$emit("update", 1);
  },
};
</script>